<lepi-fieldset [label]="label()" [required]="isRequired() ? 'true' : 'false'">
  <label
    (clickOutside)="open.set(false)"
    (click)="!hideOverlay() ? handleOpen($event) : null"
    (keydown.enter)="!hideOverlay() ? handleOpen($event) : null"
    tabindex="0"
    class="input h-10 input-bordered hidden md:inline-flex items-center gap-0 cursor-pointer hover:border-primary/40 transition-colors duration-200 focus-within:input-primary focus-within:ring-2 focus-within:ring-primary/20"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin">
    <span class="icon-[mdi--calendar-outline] text-base text-base-content/40 shrink-0 mr-1.5"></span>
    <input
      style="caret-color: transparent"
      #yearRef
      placeholder="YYYY"
      [value]="year()"
      class="w-[5ch] text-center text-sm placeholder-base-content/30 bg-transparent outline-none cursor-pointer"
      maxlength="4"
      (keydown)="yearKeydown($event)"
      (paste)="handlePaste($event)" />
    <span class="text-base-content/20 text-xs select-none">/</span>
    <input
      style="caret-color: transparent"
      #monthRef
      placeholder="MM"
      [value]="month()"
      class="w-[3ch] text-center text-sm placeholder-base-content/30 bg-transparent outline-none cursor-pointer"
      maxlength="2"
      (keydown)="monthKeydown($event)"
      (paste)="handlePaste($event)" />
    <span class="text-base-content/20 text-xs select-none">/</span>
    <input
      style="caret-color: transparent"
      #dayRef
      placeholder="DD"
      [value]="day()"
      class="w-[3ch] text-center text-sm placeholder-base-content/30 bg-transparent outline-none cursor-pointer"
      maxlength="2"
      (paste)="handlePaste($event)"
      (keydown)="dayKeydown($event)" />
    @if ((year() || month() || day()) && !hideOverlay()) {
      <span
        role="button"
        tabindex="0"
        (click)="reset(); $event.stopPropagation()"
        (keydown.enter)="reset(); $event.stopPropagation()"
        class="icon-[mdi--close-circle] text-base cursor-pointer text-base-content/30 hover:text-base-content/60 transition-colors ml-1 shrink-0">
      </span>
    }
  </label>

  <input
    type="date"
    [value]="dateString()"
    (input)="updateDateFromInput($event)"
    class="input input-bordered input-sm md:hidden" />
</lepi-fieldset>

@if (!hideOverlay()) {
  <ng-template
    #calendar
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open()"
    (detach)="open.set(false)"
    (clickOutside)="open.set(false)">
    <div
      class="rounded-xl shadow-xl border border-base-300 bg-base-100 overflow-hidden mt-1"
      tabindex="0"
      role="dialog"
      (click)="handleOpen($event)"
      (keydown.enter)="handleOpen($event)">
      <lepi-pick-calendar [(value)]="value" />
      <div class="flex w-full justify-end border-t border-base-content/5 p-4 bg-base-100">
        <button class="btn btn-primary" (click)="open.set(false); confirmed.emit(); $event.stopPropagation()">
          확인
        </button>
      </div>
    </div>
  </ng-template>
}
